import React from 'react'
import styled from 'styled-components'
import { trash, check_mark } from '../../assets'

const TableData = ({resourceTitle, description, resourceUrl, resourceDesc, datePublished, setUpdateUIWithout, setCanEdit, roleId}) => {
    const onDelete = ()=> {
        // setUpdateUIWithout(user.userId)
        // dispatch(deleteResources(user.userId))
    }
    
    const onEdit = ()=> {
        setCanEdit(roleId)
        // dispatch(editResourceCategory(category.resourceCategoryId))
    }

  return (
    <Container>
        <div>
            <ul>
                <li>{resourceTitle}</li>
                <li>{description}</li>
                <li>{resourceUrl}</li>
                <li>{resourceDesc}</li>
                <li>{datePublished}</li>
                <li>
                    <ul>
                        <li> <img src={trash} alt="trash can" onClick={ onDelete } /> </li>
                        <li> <img src={check_mark} alt="edit" onClick={ onEdit } /> </li>
                    </ul>
                </li>
            </ul>
        </div>
        
        
    </Container>
  )
}

const Container = styled.section`
    display: flex;
    width: 100%;
    margin-top: 2rem;

    & > div {
        width: inherit;
        &  ul {
        display: flex;
        justify-content: space-between;
        width: 100%;
        background-color: #ebeced;
        border-bottom: 1px solid;

        &  li {
            font-size: 12px;
            color: #667085;
            padding: 13px;
            flex: 1;

            & > ul {
                border-bottom: none;
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                &  li {
                    padding: 0;
                    cursor: pointer;
                    width: max-content;
                    width: 50%;
                    margin-right: 0;

                    & > img {
                        /* width: max-content; */
                        width: 20px;
                    }
                }
            }
        }
    }

    }
    
`

export {TableData}